import {listOfferTemplateBindingDefinitions} from "@project/sdk/sales";
import {ListOfferTemplateBindingDefinitionsResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {offerTemplateKeys} from "../../../offerTemplate-keys";
import {assertOfferTemplateBindingDefinitions} from "../../../offerTemplate-read";

export function listOfferTemplateBindingDefinitionsQueryOptions() {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryKey: offerTemplateKeys.bindingDefinitions(),
    queryFn: async ({signal}) => {
      const response = await listOfferTemplateBindingDefinitions({signal});
      const parsed = ListOfferTemplateBindingDefinitionsResponse.parse(response);
      assertOfferTemplateBindingDefinitions(parsed, response);
      return parsed;
    },
  });
}
